<template>
  <div class="trip-to-success-section" role="region" aria-labelledby="trip-to-success-title">
    <b-container fluid>
      <b-row class="align-items-center">

        <b-col md="8">
          <div>
            <h3 class="title" id="trip-to-success-title">رحلتك نحو التفوق تبدأ من هنا</h3>
            <p class="desc mb-3">
              تأهيل الطلاب لاجتياز الامتحانات النهائية بدرجات عالية، تحسين مهارات التفكير والتحليل لدى الطلاب
              لتقديم شرح بسيط ومبسط للمفاهيم الصعبة، تحضير الطلاب للاختبارات المؤهلة للجامعات داخل وخارج الدولة.
              <br><br>
              ابدأ الآن و ارفع مستواك الدراسي مع البارون، التفوق في متناول يديك، لديك أفضل مدرسين، أفضل محتوى، نتائج
              مضمونة.
            </p>
            <b-button  class="mt-3" variant="brand" size="md"  @click="goToRoute('courses')" aria-label="تصفح المواد الدراسية مع البارون">تصفح
              المواد</b-button>
          </div>
        </b-col>

        <b-col md="4" class="text-center mb-4 mb-md-0">
          <img src="../../assets/images/trip_to_img.png" 
               alt="صورة توضيحية لطلاب يحققون التفوق الأكاديمي من خلال منصة البارون التعليمية" 
               class="section-img" />
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'TripToSuccess',
  data() {
    return {};
  },
  methods: {
    goToRoute(route) {
      this.$router.push({ name: route });
    }
  }
};
</script>

<style scoped>
.trip-to-success-section {
  padding: 50px 85px !important;
}

.trip-to-success-section .title {
  color: black;
  font-size: 40px !important;
  font-weight: bold !important;
  margin-bottom: 40px;
}

.trip-to-success-section .desc {
  font-size: 1.2rem !important;
}

.section-img {
  width: 100%;
  max-width: 350px;
  height: auto;
}

.trip-to-success-section button {
  float: left;
  margin-left: 150px;
}

/* tablet */
@media (max-width: 991.98px) {
  .trip-to-success-section {
    padding: 0px 30px 40px !important;
  }

  .trip-to-success-section button {
    float: right;
    margin-left: 0;
  }

  .trip-to-success-section .title {
    font-size: 32px !important;
    margin-bottom: 24px;
  }

  .trip-to-success-section img {
    width: 80% !important;
  }
}

/* mobile */
@media (max-width: 767.98px) {
  .trip-to-success-section {
    padding: 0px 10px 40px !important;
  }

  .trip-to-success-section .title {
    font-size: 26px !important;
  }

  .trip-to-success-section .desc {
    font-size: 1.05rem !important;
  }

  .trip-to-success-section button {
    float: right;
    margin-left: 0;
  }
}
</style>
